export enum AdminConfigCurrencyModalTitle {
  create = "Добавить",
  delete = "Удалить",
}
